function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import lazyGettext from 'js-utils/lazy-gettext';
import gettext from 'js-utils/gettext';
import EBPropTypes from 'js-utils/prop-types';
import IconButton from '../iconButton/IconButton';
import InputField from '../inputField/InputField';
import { TYPE_SUBMIT } from '../button/constants';
import { DEFAULT_SEARCH_QUERY } from './constants';
import MagnifyingGlassChunkySvg from '../iconography/icons/MagnifyingGlassChunky';
import CrossChunkySvg from '../iconography/icons/CrossChunky';

var SearchFilter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchFilter, _PureComponent);

  function SearchFilter(props) {
    var _this;

    _classCallCheck(this, SearchFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchFilter).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_submitFilters", function () {
      var searchQuery = _this.state.searchQuery;
      var onFilter = _this.props.onFilter;

      if (onFilter) {
        onFilter({
          searchQuery: searchQuery
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSubmit", function (e) {
      e.preventDefault();

      _this._submitFilters();
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchChange", function (searchQuery) {
      var onChange = _this.props.onChange;

      _this.setState({
        searchQuery: searchQuery
      });

      if (onChange) {
        onChange({
          searchQuery: searchQuery
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchBlur", function () {
      _this.setState({
        isSearchFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchFocus", function () {
      _this.setState({
        isSearchFocused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchClear", function () {
      _this.setState({
        searchQuery: '',
        isSearchFocused: true
      }, _this._submitFilters);
    });

    _this.state = {
      searchQuery: props.searchQuery,
      isSearchFocused: false
    };
    return _this;
  }

  _createClass(SearchFilter, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        searchQuery: nextProps.searchQuery
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inputId = _this$props.inputId,
          inputLabel = _this$props.inputLabel,
          inputPlaceholder = _this$props.inputPlaceholder;
      var _this$state = this.state,
          searchQuery = _this$state.searchQuery,
          isSearchFocused = _this$state.isSearchFocused;
      var submitSearchButton = React.createElement(IconButton, {
        "data-spec": "search-submit-button",
        iconType: React.createElement(MagnifyingGlassChunkySvg, null),
        title: inputLabel,
        type: TYPE_SUBMIT
      });
      var clearSearchButton;

      if (searchQuery) {
        clearSearchButton = React.createElement(IconButton, {
          "data-spec": "search-clear-button",
          iconType: React.createElement(CrossChunkySvg, null),
          title: gettext('Clear search'),
          onClick: this._handleSearchClear
        });
      }

      return React.createElement("form", {
        onSubmit: this._handleSubmit,
        "data-spec": "search-filter-form"
      }, React.createElement(InputField, {
        value: searchQuery,
        style: "basic",
        prefix: submitSearchButton,
        suffix: clearSearchButton,
        id: inputId,
        "data-spec": "search-filter-input",
        label: inputLabel,
        placeholder: inputPlaceholder,
        hasMinAsideSpacing: true,
        autoComplete: "off",
        onChange: this._handleSearchChange,
        onBlur: this._handleSearchBlur,
        onFocus: this._handleSearchFocus,
        shouldFocus: isSearchFocused
      }));
    }
  }]);

  return SearchFilter;
}(PureComponent);

_defineProperty(SearchFilter, "propTypes", {
  /**
   * Initial search filter
   */
  searchQuery: PropTypes.string,

  /**
   * Function called when new filter is chosen
   */
  onFilter: PropTypes.func,

  /**
   * Function called with every keypress change of filter
   */
  onChange: PropTypes.func,

  /**
   * ID of search field
   */
  inputId: PropTypes.string,

  /**
   * Hidden label of search field
   */
  inputLabel: EBPropTypes.translation,

  /**
   * Search field place holder
   */
  inputPlaceholder: PropTypes.string
});

_defineProperty(SearchFilter, "defaultProps", {
  searchQuery: DEFAULT_SEARCH_QUERY,
  inputId: 'search-filter-form',
  inputLabel: lazyGettext('Search')
});

export { SearchFilter as default };